/**
 * Vue i18n bootstrap module
 * Configures singleton i18n instance with cookie-based locale detection
 */

import { createI18n } from "vue-i18n";
import enMessages from "./locales/en.json";
import deMessages from "./locales/de.json";

/**
 * Get user language from ASP.NET Core culture cookie
 * Cookie format: .AspNetCore.Culture=c=xx|uic=xx (URL encoded)
 */
function getLocaleFromCookie(): string | undefined {
  if (typeof document === "undefined") {
    return undefined;
  }

  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (name === ".AspNetCore.Culture") {
      try {
        const decoded = decodeURIComponent(value);
        const cultureMatch = decoded.match(/c=([a-z]{2})/i);
        if (cultureMatch?.[1]) {
          return cultureMatch[1].toLowerCase();
        }
      } catch {
        // Ignore parsing errors
      }
    }
  }

  return undefined;
}

/**
 * Determine initial locale from cookie or fallback to 'en'
 */
function getInitialLocale(): string {
  const cookieLocale = getLocaleFromCookie();
  if (cookieLocale === "de" || cookieLocale === "en") {
    return cookieLocale;
  }
  return "en";
}

/**
 * Singleton i18n instance configured with messages and cookie-based locale
 */
export const i18n = createI18n({
  legacy: false,
  flatJson: true,
  locale: getInitialLocale(),
  fallbackLocale: "en",
  messages: {
    en: enMessages,
    de: deMessages,
  },
});

/**
 * Default export for convenience
 */
export default i18n;
